"use client"

import { DatabaseRecord } from "@/core/repos/table.repo";
import { Suspense, useState } from "react";
import { ConfigProvider, Select } from "antd";
import { MODAL_THEME } from "@/core/themes/modal.theme";
import { CONTRACT_REPORT_CONFIGS } from "./configs/contract-report";
import { DEPOSITS_REPORT_CONFIGS } from "./configs/deposits-report";
import { useSearchParams } from "react-router";
import { ReportTable, ReportTableConfigs } from "@/app/home/components/report/ReportTable";

function CustomerReport() {
    const reportConfigs: {name: string, props: ReportTableConfigs<DatabaseRecord, any>}[] = [
        DEPOSITS_REPORT_CONFIGS,
        CONTRACT_REPORT_CONFIGS,
    ]
    const [searchParams] = useSearchParams();
    const reportIndexParam = searchParams.get('type');
    const getParamIndex = () => {
        let index = 0;
        if (!reportIndexParam) return 0;
        try {
            index = parseInt(reportIndexParam);
            if (index > reportConfigs.length - 1) index = reportConfigs.length - 1;
        } catch (err) {} 
        return index;
    }
    const [reportProps, setReportProps] = useState<ReportTableConfigs<DatabaseRecord, any>|null>(reportConfigs[getParamIndex()].props);
    const [reportIndex, setReportIndex] = useState(getParamIndex());
    const onReportSelect = (index: number) => {
        setReportIndex(index);
        setReportProps(reportConfigs[index].props);
    }

    return <div>
        <ConfigProvider theme={MODAL_THEME}>
            <div className="mx-4 mt-6">
                <p className="mb-2 text-[16px] font-[400]">Chọn loại báo cáo:</p>
                <Select className="w-full" value={reportIndex} onChange={onReportSelect}>
                    {reportConfigs.map((report, i) => (
                        <Select.Option key={report.name} value={i}>{report.name}</Select.Option>
                    ))}
                </Select>
            </div>
        </ConfigProvider>
        {reportProps!=undefined
            ?<ReportTable
                reportIndex={reportIndex}
                config={reportProps}
                />
            :null}
    </div>
}


export default function CustomerReportPage() {
    return <Suspense>
        <CustomerReport />
    </Suspense>
}